<!--
 * @Author: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @Date: 2024-07-29 13:59:24
 * @LastEditors: liulipeng liulipeng@longfor.com
 * @LastEditTime: 2025-12-23 14:35:21
 * @FilePath: /qd-yunjing-web/src/components/base-pagination/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置
-->
<template>
  <el-pagination
    v-if="total > 0"
    v-model:current-page="currentPage"
    :page-sizes="pageSizes"
    :pager-count="pagerCount"
    :layout="layout"
    :total="total"
    :hide-on-single-page="hideOnSinglePage"
    @size-change="changeSize"
    @current-change="changeCurrent"
  />
</template>
<script lang="ts">
  import {
    defineComponent, reactive, toRefs, watch,
  } from 'vue';

  export default defineComponent({
    name: 'base-pagination',
    props: {
      layout: {
        type: String,
        default: 'total, sizes, prev, pager, next',
      },
      // 只有一页时是否隐藏
      hideOnSinglePage: {
        type: Boolean,
        default: false,
      },
      pageNum: {
        type: Number,
        default: 1,
      },
      pageSizes: {
        type: Array<number>,
        default: () => [20, 50, 100, 200],
      },
      total: {
        type: Number,
        default: 0,
      },
      pagerCount: {
        type: Number,
        default: 5,
      },
    },
    emits: {
      'size-change': null,
      'current-change': null,
    },
    setup(props, ctx) {
      const state = reactive({
        currentPage: 1,
      });

      watch(() => props.pageNum, (newVal) => {
        state.currentPage = newVal;
      }, {
        immediate: true,
      });

      function changeSize(value: number) {
        ctx.emit('size-change', value);
      }

      function changeCurrent(value: number) {
        ctx.emit('current-change', value);
      }

      return {
        ...toRefs(state),
        changeSize,
        changeCurrent,
      };
    },
  });
</script>
